import {ModalTiteledWindow} from "./modalWindow.js";
import { TimetableCourse } from "../timetableCourse.js";
import {DataView} from '../dataview.js';
import {groupClassNames} from '../util.js';
import { TimetableSubstitution } from "../timetableSubstitution.js";


export class ModalShowTimetableItem extends ModalTiteledWindow {

   constructor(lessonGroup, view, user, dm) {
      super();
      this.dm = dm;
      this.user = user;
      this.load(lessonGroup, view);
      this.panel.classList.add('modal-show-timetable-item');
   }

   load(lessonGroup, view) {

      const gridPositions = {
         weekday: [2,2,2,2,2],
         hour:    [1,1,1,1,1,1,1,1,1,1],
         watches: [1, 1, 1, 1]
      };

      lessonGroup.onCourseClick = (course) => this.onLoadCourse(course);

      //console.log(lessonGroup);
      const date = new Date(lessonGroup.date);
      const dateStr = lessonGroup.mode === 'regular' ? Date.getGermanWeekday((date.getDay()+6)%7, true) : date.toGermanDate(true, true);

      this.elContainer = HTMLElement.createFromHTML(`
         <div class="container">
            <div class="title">${dateStr}</div>
            <div class="timetable-grid">
               <div class="timetable-cell hour-name" style="grid-area: 1 / 1"><div class="hour"></div></div>
            </div>
            <div class="pupils"></div>
         </div>
      `);

      if (this.user.type === 'teacher') {
         this.elContainer.querySelector('.pupils').innerText = 'Bitte wählen Sie einen Kurs, um die Schülerliste anzuzeigen.';
      }

      const elTimetable = this.elContainer.querySelector('.timetable-grid');
      lessonGroup.render(elTimetable, gridPositions, this.dm);
      this.elContainer.querySelector('.timetable-grid .hour-name .hour').innerText = lessonGroup.hour;
      this.elContainer.querySelector('.timetable-item').onclick = (e) => {};

      const courses = [];
      const substitutions = [];

      lessonGroup.courses.map(ttCourse => {
         if (ttCourse instanceof TimetableCourse) {
            if (ttCourse.course) courses.push(ttCourse.course);
            ttCourse.substitutions.map(subst => substitutions.push(subst));
         }
         else {
            substitutions.push(ttCourse);
         }
      });

      substitutions.map(subst => {
         if (subst.classes.length > 0 && subst.titles.length > 0) {
            const course = this.dm.getCourseByTitle(subst.classes[0], subst.titles[0]);
            if (course) {
               courses.push(course);
            }
         }
      });

      this.setTitle('Stundenplan');
      this.appendToBody(this.elContainer);

      setTimeout(() => this.show(), 100);

   }

   onLoadCourse(ttCourse) {
      
      console.log(ttCourse);

      if (this.user.type !== 'teacher') return;

      let course = null;

      if (ttCourse instanceof TimetableCourse) {
         course = ttCourse.course;
      }
      else if (ttCourse instanceof TimetableSubstitution) {
         if (ttCourse.classes.length > 0 && ttCourse.titles.length > 0) {
            course = this.dm.getCourseByTitle(ttCourse.classes[0], ttCourse.titles[0]);
         }
      }

      console.log(course);

      if (!course) return;

      let listSettings = {
         columns: [
            {
               title: 'Nachname',
               data: 'lastName',
               sort: { index: 1, dir: 1 },
               css: { height: '1.5rem' }
            },
            {
               title: 'Vorname',
               data: 'firstName',
               sort: { index: 2, dir: 1 }
            },
            {
               title: 'Klasse',
               data: (pupil) => {
                  return pupil.class.name;
               },
               sort: { index: 3, dir: 1, value: function(pupil) {
                  return (pupil.class.name.search(/^\d\d/) === -1) ? '0' + pupil.class.name : pupil.class.name;
               }}

            }
         ]
      };

      let pupils = course.pupils
      .map(id => { return this.dm.getPupil(id) })
      .filter(pupil => ttCourse.classes.includes(pupil.classId));
      let classes = this.dm.classGrouper.group(ttCourse.classes).join(',');
      pupils = pupils.filter(pupil => pupil);

      console.log(this.elContainer);
      const elPupils = this.elContainer.querySelector('.pupils');
      elPupils.empty();
      let elCourseTitle = elPupils.createElement('div', 'course-title');
      elCourseTitle.innerHTML = 'Schülerliste ' + classes + ' ' + course.short + ' (' + course.pupils.length + ')';
      let elList = elPupils.createElement('div', 'pupils-list');
      this.list = new DataView(elList);
      this.list.load(pupils, listSettings);

   }


}
